export class TaxApplication {


    companyName: string;
    personName: string;
    invoiceNumber: string;
    emailAddress: string;
    phoneNumber: string;
    paid: string;
    paidComments: string;
    amountBilledLcsa: number;
    amountPaidLcsa: number;
    question10: string;
    question11: string;
    question11Comment: string;
    datePaid: Date;

}
